import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TriggerDao } from '../../../core/services/dao/triggerDao';
import { Action } from '../../../core/models/action';

interface ActionOption extends Action {
  selected: boolean;
}

@Component({
  selector: 'clone-trigger',
  templateUrl: './clone-trigger.component.html',
  styleUrls: ['./clone-trigger.component.scss']
})
export class CloneTriggerComponent implements OnInit {
  trigger: any;
  actions: ActionOption[];
  loading = true;
  cloning = false;
  model = { numOfCopies: 1 };

  constructor(
    public dialogRef: MatDialogRef<CloneTriggerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private triggerDao: TriggerDao
  ) {}

  ngOnInit() {
    const trigger = this.data.model;
    this.triggerDao.loadById(trigger.id).subscribe(res => {
      this.trigger = res;
      this.actions = this.trigger.actions.map(action => {
        let act = action as ActionOption;
        act.selected = false;
        return act;
      });
      this.loading = false;
    });
  }

  create() {
    this.cloning = true;
    const selectedActions = [];
    this.actions.forEach(act => {
      if (act.selected) {
        selectedActions.push(act.id);
      }
    });
    // this.triggerDao.clone(this.trigger.id, this.model.numOfCopies, selectedActions).subscribe(triggers => {
    //   this.cloning = false;
    //   this.dialogRef.close(triggers);
    // });
  }

  selectAction(evt, act) {
    this.actions = this.actions.map(action => {
      if (action.friendlyName === act.friendlyName) {
        action.selected = evt.checked;
      }
      return action;
    });
  }

  toggleAllSelected(evt) {
    this.setActionSelections(evt.checked);
  }

  setActionSelections(status) {
    this.actions.forEach(act => {
      act.selected = status;
    });
  }
}
